var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-container",class:{
       'filled': _vm.isFilled,
       'focused': _vm.isFocused
     }},[_c('span',{staticClass:"placeholder"},[_vm._v(_vm._s(_vm.label))]),_c('textarea',{attrs:{"disabled":_vm.disabled},domProps:{"value":_vm.value},on:{"focus":_vm.onFocus,"blur":_vm.onBlur,"input":function($event){return _vm.$emit('input', $event.target.value)}}})])}
var staticRenderFns = []

export { render, staticRenderFns }